import { Redirect, Route, Router, Switch } from 'react-router-dom';
import HomePage from './website/HomePage';
import AboutUs from './website/AboutUs';
import HowItWorks from './website/HowItWorks';
import TermsAndConditions from './website/TermsAndConditions';
import ContactUs from './website/ContactUs';
import ScrollToTop from './utils/ScrollToTop';
import { createBrowserHistory } from 'history';
import Login from './website/Login';
import SignUp from './website/SignUp';
import React, { Suspense } from 'react';
import { Box, CircularProgress } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { RootStore } from './store/store';
import ForgetPassword from './website/ForgetPassword';
import ResetPassword from './website/ResetPassword';

const Dashboard = React.lazy(() => import('./dashboard/Dashboard'));

const history = createBrowserHistory();

const Routes = () => {
  const auth = useSelector((state: RootStore) => state.ui.token);

  let authRoutes: any = [];
  let protectedRoutes: any = [];

  if (!auth) {
    authRoutes = [
      <Route key={Math.random()} path="/login" component={Login} />,
      <Route key={Math.random()} path="/signup" component={SignUp} />,
      <Route key={Math.random()} path="/forget-password" component={ForgetPassword} />,
      <Route key={Math.random()} path="/reset-password" component={ResetPassword} />,
    ];
  }

  if (auth) {
    protectedRoutes = [
      <Route
        key={Math.random()}
        path="/dashboard"
        render={() => (
          <Suspense
            fallback={
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: '#594684' }}>
                <CircularProgress color="inherit" size="4rem" />
              </Box>
            }
          >
            <Dashboard />
          </Suspense>
        )}
      />,
    ];
  }

  return (
    <Router history={history}>
      <ScrollToTop />
      <Switch>
        <Route path="/" exact component={HomePage} />
        <Route path="/about-us" component={AboutUs} />
        <Route path="/contact-us" component={ContactUs} />
        <Route path="/how-it-works" component={HowItWorks} />
        <Route path="/terms-and-conditions" component={TermsAndConditions} />

        {protectedRoutes}
        {authRoutes}

        <Route path="*" render={() => <Redirect to="/" />} />
      </Switch>
    </Router>
  );
};

export default Routes;
